import { useState, useCallback, useRef } from 'react';
import { fetchExploreChannels, fetchBlockPreviews } from '@ego/api';
import { relativeTime } from '@ego/domain';
import { groupBlockPreviews, padPreviews } from '../utils/groupBlockPreviews';

export default function useExploreChannels() {
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(false);
  const loaded = useRef(false);

  const load = useCallback(async () => {
    if (loaded.current) return;
    setLoading(true);

    try {
      const items = await fetchExploreChannels();
      const channelIds = items.map(ch => ch.id);
      const previewBlocks = await fetchBlockPreviews(channelIds);
      const previewsByChannel = groupBlockPreviews(previewBlocks);

      setChannels(items.map(ch => ({
        ...ch,
        updatedRelative: relativeTime(ch.updatedAt),
        previews: padPreviews(previewsByChannel[ch.id] || []),
      })));
      loaded.current = true;
    } catch (err) {
      console.error('[useExploreChannels] Failed to load channels:', err);
      setChannels([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return { channels, loading, load };
}
